export const dataSources = {
  CDS: 'cds'
};

export const groups = {
  CAMPAIGN: 'campaign',
  PERFORMANCE: 'performance',
  PARTNER: 'partner'
};

const PARTNER_METRICS = [
  {
    name: 'RPS',
    title: 'Revenue Per Session (Campaign Revenue / Realized Sessions)',
    group: groups.PARTNER,
    property: 'minionEps',
    requiredProperties: ['campaignRevenue', 'adUnitSessions'],
    formula: 'ratio',
    format: 'currency'
  },
  {
    name: 'Profit',
    title: 'Profit (Total Campaign Revenue - Partner Rev)',
    group: groups.PARTNER,
    property: 'flowProfit',
    requiredProperties: ['campaignRevenue', 'partnerRevenue'],
    formula: 'getProfit',
    format: 'currency'
  },
  {
    name: 'Realized Sessions',
    title:
      'A session where the user took at least one known action. P1 View is the most common trigger.',
    group: groups.PARTNER,
    property: 'adUnitSessions',
    format: 'number',
    formula: 'sum',
    requiredProperties: ['adUnitFlowSessions', 'adUnitServerRenderSessions']
  },
  {
    hidden: true,
    name: 'Ad Unit Sessions (Flow)',
    title: 'Number of Ad Unit Sessions (Flow)',
    group: groups.PARTNER,
    property: 'adUnitFlowSessions',
    format: 'number',
    esValueAccessor: 'adUnitFlowSessions.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'pageProcess'
              }
            },
            {
              term: {
                'properties.pageNavigationIndex': 1
              }
            },
            {
              range: {
                'properties.totalOffersAvailable': {
                  gt: 0
                }
              }
            }
          ]
        }
      }
    }
  },
  {
    hidden: true,
    name: 'Ad Unit Sessions (Server Render)',
    title: 'Number of Ad Unit Sessions (Server Render)',
    group: groups.PARTNER,
    property: 'adUnitServerRenderSessions',
    format: 'number',
    esValueAccessor: 'adUnitServerRenderSessions.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'startAdUnitSession'
              }
            },
            {
              range: {
                'properties.totalOffersAvailable': {
                  gt: 0
                }
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Served',
    hidden: true,
    title: 'Number of Offers Served',
    group: groups.PERFORMANCE,
    property: 'offersServed',
    format: 'number',
    esValueAccessor: 'offersServed.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'serve'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Partner Rev (Ad Unit Server Render)',
    hidden: true,
    title: 'Partner Rev (Ad Unit Server Render)',
    group: groups.PARTNER,
    property: 'partnerRevAdUnitServerRender',
    format: 'currency',
    esValueAccessor: 'partnerRevAdUnitServerRender.partnerRevenue.value',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'startAdUnitSession'
              }
            },
            {
              range: {
                'properties.totalOffersAvailable': {
                  gt: 0
                }
              }
            }
          ]
        }
      },
      aggs: {
        partnerRevenue: {
          sum: {
            field: 'properties.partnerRevenue'
          }
        }
      }
    }
  },
  {
    name: 'Partner Rev (Ad Unit Flow)',
    hidden: true,
    title: 'Partner Rev (Ad Unit Flow)',
    group: groups.PARTNER,
    property: 'partnerRevAdUnitFlow',
    format: 'currency',
    esValueAccessor: 'partnerRevAdUnitFlow.partnerRevenue.value',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'pageProcess'
              }
            },
            {
              term: {
                'properties.pageNavigationIndex': 1
              }
            },
            {
              range: {
                'properties.totalOffersAvailable': {
                  gt: 0
                }
              }
            }
          ]
        }
      },
      aggs: {
        partnerRevenue: {
          sum: {
            field: 'properties.partnerRevenue'
          }
        }
      }
    }
  },
  {
    name: 'Partner Revenue (Conversion)',
    hidden: true,
    title: 'Partner Revenue (Conversion)',
    group: groups.PARTNER,
    property: 'partnerRevenueConvert',
    format: 'currency',
    esValueAccessor: 'partnerRevenueConvert.partnerRevenue.value',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'convert'
              }
            }
          ]
        }
      },
      aggs: {
        partnerRevenue: {
          sum: {
            field: 'properties.partnerRevenue'
          }
        }
      }
    }
  },
  {
    name: 'Partner Revenue',
    title: 'Partner Revenue',
    group: groups.PARTNER,
    property: 'partnerRevenue',
    hidden: true,
    format: 'currency',
    formula: 'sum',
    requiredProperties: [
      'partnerRevAdUnitFlow',
      'partnerRevAdUnitServerRender',
      'partnerRevenueConvert'
    ]
  },
  {
    name: 'Potential Sessions',
    hidden: false,
    title:
      'Sessions where there was an initial call to Fluent. Does not indicate session reached the users device.',
    group: groups.PARTNER,
    property: 'offersServeSession',
    format: 'number',
    esValueAccessor: 'offersServeSession.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'serveSession'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'No Offer Sessions',
    hidden: false,
    title: 'Sessions with no offers to show, nothing is eligible.',
    group: groups.PARTNER,
    property: 'offersServeSessionNoOffers',
    format: 'number',
    esValueAccessor: 'offersServeSessionNoOffers.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'serveSession'
              }
            },
            {
              term: {
                'properties.totalOffersAvailable': 0
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Offers Returned Sessions',
    hidden: false,
    title:
      'Sessions where 1 or more offers were returned. Does not indicate session reached the users device.',
    group: groups.PARTNER,
    property: 'offersServeSessionWithOffers',
    format: 'number',
    esValueAccessor: 'offersServeSessionWithOffers.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'serveSession'
              }
            },
            {
              range: {
                'properties.totalOffersAvailable': {
                  gt: 0
                }
              }
            }
          ]
        }
      }
    }
  }
];

const PERFORMANCE_CAMPAIGN_METRICS = [
  {
    name: 'Views',
    hidden: true,
    title: 'Number of Campaign Views',
    group: groups.PERFORMANCE,
    property: 'offerViews',
    format: 'number',
    esValueAccessor: 'offerViews.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'view'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Partner Views',
    hidden: true,
    title: 'Number of Partner Views',
    group: groups.PARTNER,
    property: 'partnerViews',
    format: 'number',
    esValueAccessor: 'partnerViews.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'partnerView'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'partnerCampaign'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Clicks',
    hidden: true,
    title: 'Number of Campaign Clicks',
    group: groups.PERFORMANCE,
    property: 'offerClicks',
    format: 'number',
    esValueAccessor: 'offerClicks.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'click'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Follow-up Clicks',
    hidden: true,
    title: 'Number of Campaign Follow-up Clicks',
    group: groups.PERFORMANCE,
    property: 'offerFollowUpClicks',
    format: 'number',
    esValueAccessor: 'offerFollowUpClicks.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'clickFollowUp'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Partner Clicks',
    hidden: true,
    title: 'Number of Partner Clicks',
    group: groups.PARTNER,
    property: 'partnerClicks',
    format: 'number',
    esValueAccessor: 'partnerClicks.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'partnerClick'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'partnerCampaign'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Click Declines',
    hidden: true,
    title: 'Number of Campaign Click Declines',
    group: groups.PERFORMANCE,
    property: 'offerClickDeclines',
    format: 'number',
    esValueAccessor: 'offerClickDeclines.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'clickDecline'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Partner Click Declines',
    hidden: true,
    title: 'Number of Partner Click Declines',
    group: groups.PARTNER,
    property: 'partnerClickDeclines',
    format: 'number',
    esValueAccessor: 'partnerClickDeclines.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'partnerClickDecline'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'partnerCampaign'
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Conversions',
    hidden: true,
    title: 'Number of Campaign Conversions',
    group: groups.PERFORMANCE,
    property: 'offerConverts',
    format: 'number',
    esValueAccessor: 'offerConverts.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'convert'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            }
          ],
          must_not: [
            { term: { 'properties.conversionTypeIntegrationId': 'click' } }
          ]
        }
      }
    }
  },
  {
    name: 'Primary Conversions',
    hidden: true,
    title: 'Number of Primary Campaign Conversions',
    group: groups.PERFORMANCE,
    property: 'primaryOfferConverts',
    format: 'number',
    esValueAccessor: 'primaryOfferConverts.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'convert'
              }
            },
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            },
            {
              term: { 'properties.conversionTypeIntegrationId': '0' }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Performance Revenue',
    hidden: true,
    title: 'Total of Performance Campaign Revenue',
    group: groups.PERFORMANCE,
    property: 'offerRevenue',
    format: 'currency',
    esValueAccessor: 'offerRevenue.revenue.value',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            },
            {
              term: {
                'eventType.keyword': 'convert'
              }
            }
          ]
        }
      },
      aggs: {
        revenue: {
          sum: {
            field: 'properties.revenue'
          }
        }
      }
    }
  }
];

//aggregate metrics across ALL campaign types (perf/jobs/data)
const CAMPAIGN_METRICS = [
  {
    name: 'Views',
    title: 'Number of Campaign Views',
    group: groups.CAMPAIGN,
    property: 'campaignViews',
    requiredProperties: ['offerViews', 'partnerViews'],
    formula: 'sum',
    format: 'number'
  },
  {
    name: 'Clicks',
    title: 'Number of Campaign Clicks',
    group: groups.CAMPAIGN,
    property: 'campaignClicks',
    requiredProperties: ['offerClicks', 'partnerClicks'],
    formula: 'sum',
    format: 'number'
  },
  {
    name: 'Follow-up Clicks',
    title: 'Number of Campaign Follow-up Clicks',
    group: groups.CAMPAIGN,
    property: 'campaignFollowUpClicks',
    requiredProperties: ['offerFollowUpClicks'],
    formula: 'sum',
    format: 'number'
  },
  {
    name: 'Click Declines',
    title: 'Number of Campaign Click Declines',
    group: groups.CAMPAIGN,
    property: 'campaignClickDeclines',
    requiredProperties: ['offerClickDeclines', 'partnerClickDeclines'],
    formula: 'sum',
    format: 'number'
  },
  {
    name: 'Conversions',
    title: 'Number of Campaign Conversions',
    group: groups.CAMPAIGN,
    property: 'campaignConversions',
    requiredProperties: ['offerConverts'],
    formula: 'sum',
    format: 'number'
  },
  {
    name: 'Primary Conversions',
    title: 'Number of Campaign Conversions using default tune goal ID of 0',
    group: groups.CAMPAIGN,
    property: 'primaryCampaignConversions',
    requiredProperties: ['primaryOfferConverts'],
    formula: 'sum',
    format: 'number'
  },
  {
    name: 'Net Revenue',
    title: 'Net Revenue (Campaign Revenue * Scrub Rate)',
    group: groups.CAMPAIGN,
    property: 'campaignRevenue',
    requiredProperties: ['offerRevenue'],
    formula: 'sum',
    format: 'currency'
  },
  {
    name: 'Gross Performance Revenue',
    hidden: true,
    title: 'Gross Performance Revenue',
    group: groups.CAMPAIGN,
    property: 'grossOfferRevenue',
    format: 'currency',
    esValueAccessor: 'grossOfferRevenue.grossRevenue.value',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            },
            {
              term: {
                'eventType.keyword': 'convert'
              }
            },
            {
              range: {
                'properties.revenue': { gt: 0 }
              }
            }
          ]
        }
      },
      aggs: {
        grossRevenue: {
          sum: {
            field: 'properties.grossRevenue'
          }
        }
      }
    }
  },
  {
    name: 'Gross Revenue',
    title: 'Total of All Campaigns Revenue',
    group: groups.CAMPAIGN,
    property: 'grossCampaignRevenue',
    requiredProperties: ['grossOfferRevenue'],
    formula: 'sum',
    format: 'currency'
  },
  {
    name: 'Adjusted Revenue',
    title: 'Net Revenue + Estimated Fulfillment Cost',
    group: groups.CAMPAIGN,
    property: 'adjustedCampaignRevenue',
    requiredProperties: ['offerRevenue', 'estimatedFulfillmentCost'],
    formula: 'sum',
    format: 'currency'
  },
  {
    name: 'Estimated Fulfillment Cost',
    title: 'Sum of Estimated Fulfillment Cost',
    group: groups.CAMPAIGN,
    property: 'estimatedFulfillmentCost',
    format: 'currency',
    esValueAccessor: 'estimatedFulfillmentCost.estimatedFulfillmentCost.value',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            },
            {
              term: {
                'eventType.keyword': 'convert'
              }
            }
          ]
        }
      },
      aggs: {
        estimatedFulfillmentCost: {
          sum: {
            field: 'properties.estimatedFulfillmentCost'
          }
        }
      }
    }
  },
  {
    name: 'Scrubbed Total',
    title: 'Gross Revenue - Adjusted Revenue',
    group: groups.CAMPAIGN,
    property: 'scrubbedTotal',
    requiredProperties: ['grossCampaignRevenue', 'adjustedCampaignRevenue'],
    formula: 'sub',
    format: 'currency'
  },
  {
    name: 'Scrub Rate',
    title: '(Gross Revenue - Adjusted Revenue) / Gross Revenue',
    group: groups.CAMPAIGN,
    property: 'scrubbedRevenue',
    format: 'percent',
    formula: 'getScrub',
    requiredProperties: ['grossCampaignRevenue', 'adjustedCampaignRevenue']
  },
  {
    name: 'RPC',
    title: 'Revenue per Click',
    group: groups.CAMPAIGN,
    property: 'campaignRPC',
    requiredProperties: ['campaignRevenue', 'campaignClicks'],
    formula: 'ratio',
    format: 'currency'
  },
  {
    name: 'Effective Rate',
    title: 'Net Effective Rate (Total Campaign Revenue / Campaign Conversions)',
    group: groups.CAMPAIGN,
    property: 'campaignEffectiveRate',
    requiredProperties: ['campaignRevenue', 'campaignConversions'],
    formula: 'ratio',
    format: 'currency'
  },
  {
    name: 'CTR',
    title: 'Click Thru Rate (Campaign Clicks / Campaign Views)',
    group: groups.CAMPAIGN,
    property: 'campaignCtr',
    requiredProperties: ['campaignClicks', 'campaignViews'],
    formula: 'ratio',
    format: 'percent'
  },
  {
    name: 'EPC',
    title: 'Earnings Per Click (Total Campaign Revenue / Campaign Clicks)',
    group: groups.CAMPAIGN,
    property: 'campaignEpc',
    format: 'currency',
    requiredProperties: ['campaignRevenue', 'campaignClicks'],
    formula: 'ratio'
  },
  {
    name: 'RPI',
    title: 'Revenue Per Impression (Total Campaign Revenue / Campaign Views)',
    group: groups.CAMPAIGN,
    property: 'campaignRpi',
    format: 'currency',
    requiredProperties: ['campaignRevenue', 'campaignViews'],
    formula: 'ratio'
  },
  {
    name: 'RPM',
    title:
      'Revenue Per Milli ((Total Campaign Revenue / Campaign Views) * 1000)',
    group: groups.CAMPAIGN,
    property: 'campaignRpm',
    format: 'currency',
    requiredProperties: ['campaignRevenue', 'campaignViews'],
    formula: 'ratioPerMilli'
  },
  {
    name: 'Conversion Rate',
    title: 'Campaign Conversion Rate (Campaign Conversions / Campaign Views)',
    group: groups.CAMPAIGN,
    property: 'campaignConversionRate',
    requiredProperties: ['campaignConversions', 'campaignViews'],
    formula: 'ratio',
    format: 'percent'
  },
  {
    name: 'Sold Rate',
    title: 'Number of Campaign Conversions / Number of Campaign Clicks',
    group: groups.CAMPAIGN,
    property: 'campaignSoldRate',
    requiredProperties: ['campaignConversions', 'campaignClicks'],
    formula: 'ratio',
    format: 'percent'
  },
  {
    name: 'Primary Sold Rate',
    title: 'Number of Primary Campaign Conversions / Number of Campaign Clicks',
    group: groups.CAMPAIGN,
    property: 'primaryCampaignSoldRate',
    requiredProperties: ['primaryCampaignConversions', 'campaignClicks'],
    formula: 'ratio',
    format: 'percent'
  },
  {
    name: 'Follow-up Primary CR',
    title:
      'Number of Primary Campaign Conversions / Number of Follow-up Clicks',
    group: groups.CAMPAIGN,
    property: 'followUpPrimaryConversionRate',
    requiredProperties: [
      'primaryCampaignConversions',
      'campaignFollowUpClicks'
    ],
    formula: 'ratio',
    format: 'percent'
  },
  {
    name: 'Views By P1',
    title: 'Campaign Views at Position 1',
    group: groups.CAMPAIGN,
    format: 'number',
    property: 'campaignViewsAtPosition1',
    esValueAccessor: 'campaignViewsAtPosition1.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'view'
              }
            },
            {
              term: {
                'properties.flowImpressionPosition': 1
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Views By P2',
    title: 'Campaign Views at Position 2',
    group: groups.CAMPAIGN,
    format: 'number',
    property: 'campaignViewsAtPosition2',
    esValueAccessor: 'campaignViewsAtPosition2.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'view'
              }
            },
            {
              term: {
                'properties.flowImpressionPosition': 2
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Views By P3',
    title: 'Campaign Views at Position 3',
    group: groups.CAMPAIGN,
    format: 'number',
    property: 'campaignViewsAtPosition3',
    esValueAccessor: 'campaignViewsAtPosition3.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'view'
              }
            },
            {
              term: {
                'properties.flowImpressionPosition': 3
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Views By P4+',
    title: 'Campaign Views at Position 4 and Beyond',
    group: groups.CAMPAIGN,
    format: 'number',
    property: 'campaignViewsAtPosition4Plus',
    esValueAccessor: 'campaignViewsAtPosition4Plus.doc_count',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'view'
              }
            },
            {
              range: {
                'properties.flowImpressionPosition': {
                  gte: 4
                }
              }
            }
          ]
        }
      }
    }
  },
  {
    name: 'Avg Position',
    title: 'Avg position of Campaigns displayed to users',
    group: groups.CAMPAIGN,
    format: 'number',
    property: 'averageFlowImpressionPosition',
    esValueAccessor: 'averageFlowImpressionPosition.impressionPosition.value',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'eventType.keyword': 'view'
              }
            },
            {
              exists: {
                field: 'properties.flowImpressionPosition'
              }
            },
            {
              range: {
                'properties.flowImpressionPosition': {
                  gt: 0
                }
              }
            }
          ],
          should: [
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            }
          ],
          minimum_should_match: 1
        }
      },
      aggs: {
        impressionPosition: {
          avg: {
            field: 'properties.flowImpressionPosition'
          }
        }
      }
    },
    requiredProperties: ['campaignViews'],
    formula: currentRow => {
      if (
        !currentRow.isSubtotalRow ||
        !Array.isArray(currentRow.rows) ||
        currentRow.campaignViews <= 0
      ) {
        return currentRow.averageFlowImpressionPosition ?? 0;
      }

      let rowsum = currentRow.rows.reduce(
        (previousValue, currentValue) =>
          previousValue +
          currentValue.campaignViews *
            currentValue.averageFlowImpressionPosition,
        0
      );

      return rowsum / currentRow.campaignViews;
    }
  },
  {
    name: 'eCPA',
    title: 'Effective CPA (Revenue / Primary Conversions',
    group: groups.CAMPAIGN,
    property: 'effectiveCPA',
    requiredProperties: ['campaignRevenue', 'primaryCampaignConversions'],
    formula: 'getECPA',
    format: 'currency'
  },
  {
    name: 'Sale Amount',
    title: 'Sale Amount',
    group: groups.CAMPAIGN,
    property: 'saleAmount',
    format: 'currency',
    esValueAccessor: 'saleAmount.saleAmount.value',
    dataSource: dataSources.CDS,
    aggs: {
      filter: {
        bool: {
          must: [
            {
              term: {
                'target.itemType.keyword': 'offer'
              }
            },
            {
              term: {
                'eventType.keyword': 'convert'
              }
            }
          ]
        }
      },
      aggs: {
        saleAmount: {
          sum: {
            field: 'properties.saleAmount'
          }
        }
      }
    }
  },
  {
    name: 'Served',
    title: 'Number of Offers Served',
    group: groups.CAMPAIGN,
    property: 'campaignServed',
    requiredProperties: ['offersServed'],
    formula: 'sum',
    format: 'number'
  },
  {
    name: 'eCR',
    title: 'Effective Conversion Rate (Primary Conversions / Campaign Views)',
    group: groups.CAMPAIGN,
    property: 'campaignEffectiveConversionRate',
    requiredProperties: ['primaryCampaignConversions', 'campaignViews'],
    formula: 'ratio',
    format: 'percent'
  }
];

export const METRICS = [
  ...PARTNER_METRICS,
  ...CAMPAIGN_METRICS,
  ...PERFORMANCE_CAMPAIGN_METRICS
];

export const FORMULAS = {
  ratio: ([a, b]) => {
    if (isNaN(a) || isNaN(b)) {
      return undefined;
    }
    if (a === 0 || b === 0) {
      return 0;
    }
    return a / b;
  },
  ratioPerMilli: ([a, b]) => {
    return FORMULAS.ratio([a, b]) * 1000;
  },
  sum: arrayOfNumbers => {
    return arrayOfNumbers.reduce((a, b) => {
      return a + (isNaN(b) ? 0 : b);
    }, 0);
  },
  sub: arrayOfNumbers => {
    return arrayOfNumbers.reduce((a, b) => {
      if (!isNaN(a) && !isNaN(b)) {
        return a - b;
      } else {
        return undefined;
      }
    });
  },
  getScrub: ([grossRev, rev]) => {
    if (isNaN(grossRev) || isNaN(rev)) {
      return 0;
    }

    if (grossRev === 0) {
      return 0;
    }

    return (grossRev - rev) / grossRev;
  },
  getECPA: ([revenue, conversions]) => {
    if (isNaN(revenue) || isNaN(conversions)) {
      return 0;
    }
    if (conversions <= 0) {
      return 0;
    }
    return revenue / conversions;
  },
  getProfit: ([revenue, partnerRev]) => {
    if (isNaN(revenue) || isNaN(partnerRev)) {
      return undefined;
    }
    return revenue - partnerRev;
  }
};

export const getDependencies = field => {
  if (!field) {
    return [];
  }
  const metric = METRICS.find(m => m.property === field);

  if (
    !metric ||
    !Array.isArray(metric.requiredProperties) ||
    metric.requiredProperties.length === 0
  ) {
    return [];
  }

  const dependencies = new Set();

  metric.requiredProperties.forEach(rp => {
    const dependentMetric = METRICS.find(m => m.property === rp);
    if (dependentMetric) {
      if (!dependencies.has(dependentMetric)) {
        dependencies.add(dependentMetric);
        const childDependencies = getDependencies(dependentMetric.property);
        childDependencies.forEach(cd => {
          if (!dependencies.has(cd)) {
            dependencies.add(cd);
          }
        });
      }
    }
  });

  return Array.from(dependencies);
};

export const COPY_DOWN_METRICS = [
  {
    groupBy: 'properties.conversionTypeName.keyword',
    metrics: ['campaignViews', 'campaignClicks']
  }
];
